import React from 'react';

export const WhyMFCT = [
	{
		id: 2,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 21,
				paragraph: [
					<p>
						MoneyFront is an investment platform that offers financial advisory
						services to its clients. We have a client-centric model where our
						top priority is to provide structured advice in all the core areas
						of treasury. We have devised effective debt laddering strategies to
						plan cash flows perfectly in sync with business requirements, and to
						park any surplus in various short-term debt instruments to amplify
						returns. We take utmost care to ensure that the credit quality of
						debt instruments is of the highest order, and we accord highest
						importance to good quality, liquidity, and returns, in that order.
					</p>,
				],
			},
			{
				id: 22,
				paragraph: [
					<p>
						We help our clients by cutting their costs, improving their cash
						flow and reducing their investment risks. Our team strives to
						deliver high-quality tailored wealth services to the clients. With
						us, you can find help with cash management, risk management, credit
						quality across various debt market instruments based on business
						requirements and cash flow patterns which can vary from overnight,
						liquid, ultra short, money market, low duration funds to corporate
						deposits, bonds, and inter-corporate deposits (ICDs).
					</p>,
				],
			},
		],
	},
	{
		id: 3,
		paragraphs:
			'For us, the client comes first, so we work with uncompromising integrity and with the aim to build long-term working relationships.',
	},
];
